enum PosicaoComplemento {
    Antes = 0,
    Depois = 1,
}

export default PosicaoComplemento;